// extracted by mini-css-extract-plugin
export default {"tagListRoot":"TagList_tagListRoot__DsQNo","tagListElement":"TagList_tagListElement__9AsKg","tagListMore":"TagList_tagListMore__4WHHp"};